import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import SearchLine from 'rebook/apps/search/components/SearchLine';
import * as SearchQueryActions from 'rebook/apps/search/actions/SearchQueryActions';
import * as AuthFormActions from 'rebook/apps/users/actions/AuthFormActions';
import { URLS } from 'rebook/apps/base/constants';
import uaDetector from 'rebook/apps/utils/uaDetector';

import HeaderUser from './HeaderUser';
import HeaderLinks from './HeaderLinks';
import styles from './style.scss';


class Header extends React.Component {
  constructor(props) {
    super(props);
    this.toggleMobileSearchLine = this.toggleMobileSearchLine.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.state = {
      showSearchForMobile: false,
      isOpenSearchLine: false,
    };
  }

  componentDidMount() {
    const UA = navigator && navigator.userAgent ? navigator.userAgent : null;
    this.state.isMobile = uaDetector.isMobile(UA);
    window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
  }

  handleClickOutside(e) {
    if (this.node.contains(e.target)) {
      return;
    }

    this.toggleMobileSearchLine();
  }

  toggleExpand() {
    this.setState(({ isExpanded }) => {
      return { isExpanded: !isExpanded };
    });
  }

  handleScroll() {
    const { isVisible, isExpanded, lastScrollTop } = this.state;

    if (isExpanded) {
      return null;
    }

    const position = window.pageYOffset || document.documentElement.scrollTop;

    if (position >= 40) {
      // add a step tp prevent header from 'dragging'
      if (Math.abs(position - lastScrollTop) > 25) {
        // downscroll event
        if (position > lastScrollTop) {
          this.setState({
            isSticky: true,
            isVisible: false,
            isNotVisible: !isVisible,
            lastScrollTop: position,
          });
        }

        // upscroll event
        else {
          this.setState({
            isSticky: true,
            isVisible: true,
            isNotVisible: !isVisible,
            lastScrollTop: position,
          });
        }
      }
    }

    // default position
    else if (position === 0) {
      this.setState({
        isSticky: false,
        isVisible: false,
        isNotVisible: false,
        lastScrollTop: position,
      });
    }

    else if (position < 40) {
      // downscroll event
      if (position > lastScrollTop) {
        this.setState({
          isSticky: false,
          isVisible: true,
          isNotVisible: false,
          lastScrollTop: position,
        });
      }
    }
  }

  toggleMobileSearchLine() {
    const { showSearchForMobile } = this.state;
    if (!showSearchForMobile) {
      document.addEventListener('click', this.handleClickOutside, false);
    }
    else {
      document.removeEventListener('click', this.handleClickOutside, false);
    }
    this.setState({ showSearchForMobile: !showSearchForMobile });
    this.props.SearchQueryActions.cancelQuery(this.props.history);
  }

  handleSearchLineFocus() {
    this.setState({ isOpenSearchLine: true });
  }

  handleSearchLineBlur() {
    this.setState({ isOpenSearchLine: false });
  }

  render() {
    const { pathname } = this.props.location;
    const { isMobile, showSearchForMobile, isOpenSearchLine } = this.state;
    return (
      <header className={classNames(styles.header, { isMobile: isMobile })}>
        <div className={styles.container}>
          {showSearchForMobile && (
            <div className={styles.mobileSearch} ref={(node) => {
              this.node = node;
            }}>
              <div className={styles.mobileSearchLine}>
                <SearchLine isFocused history={this.props.history} showCancelButton={false} />
              </div>
              <span onClick={() => {
                this.toggleMobileSearchLine();
              }}
              className={classNames(styles.mobileCancelSearch, 'link', 'jest-cancel-search-line-mobile')}>
                Отмена
              </span>
            </div>
          )}
          <Link to="/" className={classNames(styles.logo, { isMobile })} />
          <div className={classNames(styles.menuWrapper, { isMobile })}>
            <div className={classNames(styles.search, { isMobile, isOpenSearchLine })}>
              <SearchLine
                history={this.props.history}
                onFocus={(e) => {
                  this.handleSearchLineFocus(e);
                }}
                onBlur={(e) => {
                  this.handleSearchLineBlur(e);
                }} />
            </div>
            <div className={classNames(styles.menu, { isMobile })}>
              <ul className={styles.menuList}>
                <li className={styles.menuItem}>
                  <Link to={URLS.dashboard}
                    className={classNames(
                      styles.menuItemLink,
                      { activeLink: pathname.indexOf(URLS.dashboard) !== -1 },
                    )}>
                    Что читать
                  </Link>
                </li>
                <li className={styles.menuItem}>
                  <Link to={URLS.catalogIndex}
                    className={classNames(
                      styles.menuItemLink,
                      { activeLink: pathname.indexOf(URLS.catalogIndex) !== -1 },
                    )}>
                    Библиотека
                  </Link>
                </li>
                <li className={styles.menuItem}>
                  <Link to={URLS.payments}
                    className={classNames(
                      styles.menuItemLink,
                      { activeLink: pathname.indexOf(URLS.payments) !== -1 },
                    )}>
                    Подписка
                  </Link>
                </li>
                {this.props.user &&
                <li className={classNames(styles.menuItem, styles.menuItemProfile)}>
                  <Link to={`/profile/${this.props.user.id}/`} className={classNames(
                    styles.menuItemLink,
                    { activeLink: pathname.indexOf(URLS.profile) !== -1 },
                  )}>
                    Мои книги
                  </Link>
                </li>
                }
              </ul>
            </div>
          </div>
          <div className={classNames(styles.enter, { isMobile })}>
            <div
              className={classNames(styles.mobileSearchButton, 'jest-mobile-search-toggle', { isMobile })}
              onClick={() => {
                this.toggleMobileSearchLine();
              }} />
            {this.props.user ?
              (
                <HeaderUser user={this.props.user} pathname={pathname} />
              )
              :
              (
                <a href="javascript:;"
                  className={classNames(styles.link, 'jest-auth-link-hamburger')}
                  onClick={() => {
                    this.props.AuthFormActions.showForm();
                  }}>
                  Войти
                </a>
              )
            }
          </div>
          <HeaderLinks isMobile={isMobile} />
        </div>
      </header>
    );
  }
};


function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    AuthFormActions: bindActionCreators(AuthFormActions, dispatch),
    SearchQueryActions: bindActionCreators(SearchQueryActions, dispatch),
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(Header);
